module.exports = __webpack_public_path__ + "static/img/ios.3ff9987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ios.png
// module id = NiBH
// module chunks = 0